import { FilteredItem } from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { GatewayGetTransactionsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/transactions/models/inputs/gateway-get-transactions-paginated.model';

import {
  TRANSACTION_LIST_FILTER,
  TRANSACTION_LIST_FILTER_NAME_LIST,
} from '../transaction-list/transaction-list.config';
import { useTransactionListContext } from '../transaction.context';
import * as css from './transaction-list-filter-state.module.scss';

export const TransactionListFilterStateController = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useTransactionListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleRemove = <
    FilterNameKey extends keyof GatewayGetTransactionsPaginatedModel,
  >(
    filterName: FilterNameKey,
    filterValue: GatewayGetTransactionsPaginatedModel[FilterNameKey],
  ) => {
    setGetPaginatedQueryParameters((current) => {
      const queryParameterValue = current[filterName];

      if (Array.isArray(queryParameterValue) && !Array.isArray(filterValue)) {
        return {
          ...current,
          [filterName]: queryParameterValue.filter(
            (queryParameterValueItem) =>
              queryParameterValueItem !== filterValue,
          ),
        };
      }

      return {
        ...current,
        [filterName]: undefined,
      };
    });
  };

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const filterNameActiveList = TRANSACTION_LIST_FILTER_NAME_LIST.filter(
    (filterName) => getPaginatedQueryParameters[filterName] !== undefined,
  );

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack
      className={css.filtersSection}
      flex={1}
      gap={GapEnum.S}
      justifyContent="space-between"
      alignItems="center">
      <Stack
        direction="row"
        className={css.displayedFiltersSection}
        gap={GapEnum.S}
        alignItems="center"
        flex={1}>
        {filterNameActiveList
          .flatMap((filterName) => {
            const filterValue = getPaginatedQueryParameters[filterName];

            if (filterValue === undefined) {
              return [];
            }

            const FilteredItemComponent =
              TRANSACTION_LIST_FILTER[filterName]?.componentType;

            // Case 1: Query parameter is a set of values
            if (Array.isArray(filterValue)) {
              return filterValue.map((filterValueItem) => {
                if (FilteredItemComponent) {
                  return (
                    <FilteredItemComponent
                      key={`${filterName}-${filterValueItem}`}
                      value={filterValueItem}
                      onRemove={() => handleRemove(filterName, filterValueItem)}
                    />
                  );
                }

                return [
                  <FilteredItem
                    key={`${filterName}-${filterValueItem}`}
                    label={`${filterValueItem}`}
                    onRemove={() => handleRemove(filterName, filterValueItem)}
                  />,
                ];
              });
            }

            // Case 2: Query parameter is a unique value
            if (FilteredItemComponent) {
              return [
                <FilteredItemComponent
                  key={filterName}
                  value={filterValue}
                  onRemove={() => handleRemove(filterName, filterValue)}
                />,
              ];
            }

            return [
              <FilteredItem
                key={filterName}
                label={`${filterValue}`}
                onRemove={() => handleRemove(filterName, filterValue)}
              />,
            ];
          })
          .slice(0, 3)}
      </Stack>
    </Stack>
  );
};
